import { styled } from "styled-components";

export const CardCtaContainer = styled.div`
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 350px;
  background: ${({ theme }) => theme.colors.default[50]};
`;

export const CardCtaContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TextContainer = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.default[900]};
`;

export const Description = styled.p`
  font-size: 14px;
  font-weight: 550;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.default[600]};
`;
